export default __webpack_public_path__ + "static/media/s2s_test.6bd7aeac.png";